'use strict';

var isServer = typeof window === 'undefined';

/**
 * 获取query参数·
 * @private
 * @param  {String}    param，不传则获取整个query对象
 * @return {String}    不存在则返回 undefined
 */
module.exports = function (param) {
  if (isServer) return '';
  var net = require('@ali/network');
  return net.query(param) || net.query(param, decodeURIComponent(window.location.href));
};